<p-dialog [(visible)]="showDialog" [modal]="true" [dismissableMask]="true"
          [style]="{width:'95vw',height:'90vh'}" [contentStyle]="{padding:'0'}"
          styleClass="zone-map-dialog">
    <div class="map-shell">
        <google-map #gmap [center]="center" [zoom]="zoom" height="100%" width="100%" [options]="mapOptions">
            <map-marker *ngFor="let m of markers"
                        [position]="m.position"
                        [options]="m.options">
            </map-marker>
        </google-map>

        <!-- Panel de info "Compara propiedades similares" (Figma) -->
        <aside class="info-panel" [class.collapsed]="!showInfoPanel">
            <div class="info-head">
                <h3 class="info-title">Compara propiedades similares</h3>
                <button type="button" class="info-toggle" (click)="toggleInfoPanel()"
                        [attr.aria-expanded]="showInfoPanel" aria-label="Mostrar/ocultar detalle">
                    <i class="pi" [ngClass]="showInfoPanel ? 'pi-chevron-down' : 'pi-chevron-up'"></i>
                </button>
            </div>

            <p class="info-sub" *ngIf="segmentLabel || offerLabel">
                {{ segmentLabel }}<span *ngIf="segmentLabel && offerLabel"> · </span>{{ offerLabel }}
            </p>

            <div class="info-body" *ngIf="showInfoPanel">
                <ng-container *ngIf="priceStats; else noStats">
                    <h4>Precio por m² en la zona</h4>
                    <p>
                        La mayoría de las zonas están entre
                        <b>{{ statMin }} USD</b> y <b>{{ statMax }} USD</b> por m²
                        (promedio <b>{{ statAvg }} USD</b>), sobre {{ priceStats.count }} zonas.
                    </p>
                    <p class="info-hint">
                        Tu zona aparece resaltada en el mapa. Son una referencia para ayudarte a
                        definir un precio competitivo.
                    </p>
                </ng-container>
                <ng-template #noStats>
                    <p>Aún no tenemos suficientes referencias de precio para tu zona.</p>
                </ng-template>
            </div>
        </aside>
    </div>

    <ng-template pTemplate="footer">
        <button pButton type="button" (click)="closeDialog()" label="Cerrar"></button>
    </ng-template>
</p-dialog>
